<template>
    <div class="w-full">
        <div v-if="reservations.length">
            <div>
                <div v-for="booking in reservations" class="flex mt-4 mb-2 schedule-slot">
                    <div class="w-full flex flex-row justify-between items-center">
                        <div class="flex flex-col">
                            <div class="h6 text-sm text-white">Datum: {{getDate(booking.schedule.start, booking.schedule.end)}}</div>
                            <div class="text-sm text-white">Tid: {{getTime(booking.schedule.start, booking.schedule.end)}}</div>
                        </div>
                        <button type="button" v-on:click="removeReservation(booking.id)"
                                class="text-sm text-white flex flex-row items-center">
                            <img src="/images/large-cross.png" style="width: 32px; height: 32px">
                        </button>
                    </div>
                </div>

                <button class="mt-10 flex flex-row items-center text-white text-lg bg-tlmblue2 px-4 py-1 rounded" v-on:click="emitReservationsDone">Bekräfta <svg xmlns="http://www.w3.org/2000/svg" width="19.266" height="19.266" viewBox="0 0 19.266 19.266" fill="currentColor"><path class="b" d="M5.88,3.7l6.326,6.326L5.88,16.353l1.7,1.7,8.027-8.027L7.582,2Z" transform="translate(-1.16 -0.395)"/></svg></button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
    export default {
        name: "modal-reservations",
        props: ["user_id", 'company',  'consultant', 'reservations'],
        data() {
            return {
                baseURL: window.location.hostname + '/login',
                termsAccepted: false,
            }
        },
        methods: {
            consultantQueryString () {
                let url = location.pathname.split('/');
                let last = url[url.length - 1];
                if (last == 'consultant') {
                    return '?consultant=1'
                }
                return '';
            },
            getDateTime(dateString, dateStringEnd){
                return moment(dateString).format('YYYY-MM-DD') + ' kl. ' + moment(dateString).format('HH:mm') + ' - ' + moment(dateStringEnd).format('HH:mm');
            },
            getDate(dateString, dateStringEnd){
                return moment(dateString).format('YYYY-MM-DD');
            },
            getTime(dateString, dateStringEnd){
                return moment(dateString).format('HH:mm') + ' - ' + moment(dateStringEnd).format('HH:mm');
            },
            listen() {
                if(this.user_id != null) {
                    Echo.private('reservations.' + this.user_id)
                        .listen("ReservationDone", (e) => {
                            this.emitReservationsDone();
                            this.getReservations();
                        });
                    Echo.private('expired_reservations.' + this.user_id)
                        .listen("ReservationsHaveExpired", (e) => {
                            Vue.toasted.error('Reservationer har utgått');
                            this.$emit('reservationsExpired');
                            this.getReservations();
                        });
                } else {
                    Echo.channel('reservations.session.' + window.Laravel.sessionId)
                        .listen("ReservationDoneSession", (e) => {
                            this.getReservations();
                        });
                }
            },
            getPrice(treatment){
                if(treatment.treatment_price){
                    if(this.consultant) {
                        return treatment.treatment_price.total_sum + ' kr';
                    }else {
                        return treatment.treatment_price.subv_total_sum + ' kr';
                    }
                }

                return 'Odefinierat pris';
            },
            emitPayment() {
                this.$eventHub.$emit('showpayinfo');
            },
            emitReservationsDone() {
                this.$emit('reservationsDone');
            },
            removeReservations() {
                this.reservations = [];
            },
            removeReservation(id) {
                this.$emit('removeReservationWithId', id);
            },
            dateFormat: function (schedule) {
                return moment(schedule.start).format("YY-MM-DD") + " " + moment(schedule.start).format("HH:mm") + " - " + moment(schedule.end).format("HH:mm");
            },
            getLoginURL: function () {
                return window.location.hostname + '/login';
            }
        },
        computed: {},
        mounted() {
            this.listen();
            this.$eventHub.$on('showpayinfo', function () {
            });
        }
    }
</script>
<style scoped>
    .schedule-slot{
        display: flex;
        justify-content: space-between;
    }

</style>
